<template>
    <modal
        :saveAction="saveAction"
        :title="$t(title)"
        :id="id"
        :actionButtons="false"
        size="lg"
        :closeButton="true"
        @shown="shown()"
        :scrollable="true"
    >
        <template slot="modal-header">
            <span></span>
        </template>

        <div class="row" style="height:75vh; overflow-y:auto">
            <div class="col">
                <div class="card">
                    <!-- Search -->
                    <div class="row align-items-center">
                        <div class="col-auto pr-0 ml-3">
                            <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                            <span class="fe fe-search text-muted" v-else></span>
                        </div>
                        <div class="col">
                            <b-form-input
                                v-model="query"
                                class="no-glow search form-control-flush"
                                :placeholder="$t('Search')"
                            ></b-form-input>
                        </div>
                        <div class="col-auto">
                            <button
                                @click="openModal({id:modalName, model:{language:'russian'}})"
                                class="btn btn-primary"
                            >{{$t('Add')}}</button>
                        </div>
                    </div>
                </div>

                <ul class="list-group list">
                    <li class="list-group-item" v-for="(idcItem, index) in manipulations" :key="index">
                        <div class="row align-items-center" @click="use(idcItem)">
                            <div class="col-1">
                                <button class="btn btn-sm btn-white ml-2">
                                    <i class="fe fe-check"></i>
                                </button>
                            </div>
                            <div class="col-1 pointer" @click="parentId=idcItem._id">{{idcItem.code}}</div>
                            <div class="col ml-n5 pointer" @click="parentId=idcItem._id">
                                <span class="mb-1 name">{{idcItem.label}}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <manipulation-form-modal :data="model" :id="modalName"></manipulation-form-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import debounce from 'lodash/debounce';
import ManipulationFormModal from '@/Pages/Company/Manipulations/ManipulationFormModal'


export default {
    name: 'manipulation-modal',

    props: ['id', 'saveAction', 'data', 'useAction'],
    mixins: [modalMixins],
    components: {
        Modal,
        ManipulationFormModal
    },
    data() {
        return {
            query: null,
            modalName: 'manipulationFormModal',
            breadcrumbs: [],
            parentId: null,
            model: {
                language: 'russian'
            },
            params: {
                query: {
                    $limit: 100,
                    $sort: {
                        label: 1
                    }
                }
            },
            title: 'Manipulation',
        }
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
        ...mapGetters('manipulations', {
            findManipulationsInStore: 'find',
        }),

        manipulations() {
            return this.findManipulationsInStore(this.params).data;
        }
    },

    watch: {
        query: debounce(function (newVal) {
            this.queryItems();
        }, 400),
    },
    methods: {
        ...mapActions('manipulations', ['find']),
        use(item) {
            this.useAction(JSON.parse(JSON.stringify(item)));
            this.$toasted.global.success({ message: this.$t('Added successfully') });
        },

        shown() {
            this.queryItems();
        },

        queryItems() {
            if (this.query) {
                this.params.query.$or = [{
                    label: {
                        $regex: this.query,
                        $options: "i"
                    }
                },
                {
                    code: {
                        $regex: this.query,
                        $options: "i"
                    }
                },
                {
                    description: {
                        $regex: this.query,
                        $options: "i"
                    }
                },
                ];
            } else {
                delete this.params.query.$or;
            }


            this.find(this.params);

        },
    },

}
</script>
